export const LS_KEYS = {
    TOKEN: "token",
    TOKEN_EXPIRATION: "token_expires_at",
    CODE_VERIFIER: "code_verifier",
    LOCATION: "location",
  };
  